import { token } from '@/infrastructure/container';

export interface IDomTheme {
  systemPrefersDark(): boolean;
  applyDarkClass(isDark: boolean): void;
  onSystemPreferenceChanged(handler: (isDark: boolean) => void): { unsubscribe: () => void };
}

export const TOKEN_IDomTheme = token<IDomTheme>('IDomTheme');

export class DomTheme implements IDomTheme {
  private readonly query: MediaQueryList;

  constructor() {
    this.query = window.matchMedia('(prefers-color-scheme: dark)');
  }

  systemPrefersDark(): boolean {
    return this.query.matches;
  }

  applyDarkClass(isDark: boolean): void {
    document.documentElement.classList.toggle('dark', isDark);
  }

  onSystemPreferenceChanged(handler: (isDark: boolean) => void): { unsubscribe: () => void } {
    const listener = (e: MediaQueryListEvent) => handler(e.matches);
    this.query.addEventListener('change', listener);
    return { unsubscribe: () => this.query.removeEventListener('change', listener) };
  }
}

export class InMemoryDomTheme implements IDomTheme {
  systemDark = false;
  lastApplied: boolean | null = null;
  private listeners: Array<(isDark: boolean) => void> = [];

  systemPrefersDark(): boolean {
    return this.systemDark;
  }
  applyDarkClass(isDark: boolean): void {
    this.lastApplied = isDark;
  }
  onSystemPreferenceChanged(handler: (isDark: boolean) => void): { unsubscribe: () => void } {
    this.listeners.push(handler);
    return {
      unsubscribe: () => {
        this.listeners = this.listeners.filter((l) => l !== handler);
      },
    };
  }

  /** Test helper; not on the interface. */
  triggerSystemChange(isDark: boolean): void {
    this.systemDark = isDark;
    for (const l of this.listeners) l(isDark);
  }
}
